import { prespawnGeoscriptWorker } from 'src/geoscript/prespawnWorker';

export const init = () => {
  prespawnGeoscriptWorker();
};
